import { TrackerDataType } from '../../shared/constants/constants';
import { getSidebarLogIconComponent } from '../../shared/constants/logIcons';
import { queryAdderPalette } from '../../shared/constants/queryAdderPalette';
import { appPalette, neutralPalette } from '../../theme/palette';

const ServiceLogIcon = getSidebarLogIconComponent(TrackerDataType.SERVICE);
const MediaInteractionLogIcon = getSidebarLogIconComponent(TrackerDataType.MEDIA_INTERACTION);
const EngagementLogIcon = getSidebarLogIconComponent(TrackerDataType.ENGAGEMENT);
const ContentLogIcon = getSidebarLogIconComponent(TrackerDataType.CONTENT_LOG);

export const TOPIC_LINKING_COPY = {
  sectionTitle: 'Topic Linking',
  panelTitle: 'Link to Service',
  helperText: 'Connect this record to an existing Service so related work stays grouped together.',
};

export const LOG_IDENTITY_COLORS = {
  service: queryAdderPalette.service.main,
  mediaInteraction: queryAdderPalette.mediaInteraction.main,
  engagement: queryAdderPalette.engagement.main,
  content: queryAdderPalette.content.main,
};

export const getAdderColorRoles = (logColor) => ({
  systemPrimary: appPalette.primary.main,
  modalIdentityAccent: logColor,
  sectionBorder: queryAdderPalette.common.divider,
  sectionIconBackground: neutralPalette.surfacePage,
  utilityIconBackground: neutralPalette.surfacePage,
  utilityIconColor: appPalette.primary.main,
  topicLinkingBackground: neutralPalette.surfacePage,
  topicLinkingBorder: queryAdderPalette.common.divider,
  helperText: queryAdderPalette.common.helper,
});

export const LOG_ADDER_CONFIG = {
  service: {
    modalTitle: 'New Service',
    logLabel: 'Service',
    logColor: LOG_IDENTITY_COLORS.service,
    icon: <ServiceLogIcon sx={{ fontSize: 22 }} />,
  },
  mediaInteraction: {
    modalTitle: 'New Media Interaction',
    logLabel: 'Media Interaction',
    logColor: LOG_IDENTITY_COLORS.mediaInteraction,
    icon: <MediaInteractionLogIcon sx={{ fontSize: 22 }} />,
  },
  engagement: {
    modalTitle: 'New Engagement',
    logLabel: 'Engagement',
    logColor: LOG_IDENTITY_COLORS.engagement,
    icon: <EngagementLogIcon sx={{ fontSize: 22 }} />,
  },
  content: {
    modalTitle: 'New Content',
    logLabel: 'Content',
    logColor: LOG_IDENTITY_COLORS.content,
    icon: <ContentLogIcon sx={{ fontSize: 22 }} />,
  },
};

export const LOG_ADDER_CONFIG_BY_TYPE = {
  [TrackerDataType.SERVICE]: LOG_ADDER_CONFIG.service,
  [TrackerDataType.MEDIA_INTERACTION]: LOG_ADDER_CONFIG.mediaInteraction,
  [TrackerDataType.ENGAGEMENT]: LOG_ADDER_CONFIG.engagement,
  [TrackerDataType.CONTENT_LOG]: LOG_ADDER_CONFIG.content,
};
